import { ParseKeys } from 'i18next'
import { myPalette } from '~/shared/lib/theme'
import {
  AccidentRegistrationTypeEnum,
  DiskTypeEnum,
  DocumentsTypeEnum,
  IcReviewStatusEnum,
  IncidentResponsibleEnum,
  InsurancePolicyStatusEnum,
  RoadAccidentsStatusEnum,
  RepairOrderPaymentStatusEnum,
  RepairOrderStatusEnum,
  RubberTypeEnum,
  TimezoneCode,
  LocaleEnum,
} from './enums'

export const AUTH_TOKEN_STORAGE_KEY = 'auth_token'
export const AUTH_EMAIL_STORAGE_KEY = 'auth_email'
export const AUTH_CURRENT_USER_ID_STORAGE_KEY = 'auth_current_user_id'
export const USER_TAXIPARK_STORAGE_KEY = 'user_taxipark'
export const USER_PERMISSIONS_STORAGE_KEY = 'user_permissions'
export const USER_LOCALE_STORAGE_KEY = 'user_locale'
export const USER_COUNTRY_STORAGE_KEY = 'user_country'

export const MIN_COLUMN_WIDTH = 90

export type Option = { id: string; label: string }
export type OptionEnum<T> = { id: T; label: string | ParseKeys }

export const documentsCodeEnumLabels: Record<DocumentsTypeEnum, ParseKeys> = {
  [DocumentsTypeEnum.STS]: 'enum.sts',
  [DocumentsTypeEnum.OSAGO]: 'enum.osago',
  [DocumentsTypeEnum.DC]: 'enum.diagnostic card',
  [DocumentsTypeEnum.LICENSE]: 'enum.license',
}
export const documentsCodeEnumOptions: OptionEnum<DocumentsTypeEnum>[] =
  Object.keys(DocumentsTypeEnum).map((value) => {
    const label =
      documentsCodeEnumLabels[value as keyof typeof DocumentsTypeEnum]
    return {
      label,
      id: value as DocumentsTypeEnum,
    }
  })

export const diskTypeEnumLabels: Record<DiskTypeEnum, ParseKeys> = {
  [DiskTypeEnum.STAMPED]: 'enum.stamped',
  [DiskTypeEnum.STAMPED_WITH_HOOD]: 'enum.stamped with hood',
  [DiskTypeEnum.CAST]: 'enum.cast',
}
export const diskTypeEnumOptions: OptionEnum<DiskTypeEnum>[] = Object.keys(
  DiskTypeEnum,
).map((value) => {
  const label = diskTypeEnumLabels[value as keyof typeof DiskTypeEnum]
  return {
    label,
    id: value as DiskTypeEnum,
  }
})

export const rubberTypeEnumLabels: Record<RubberTypeEnum, ParseKeys> = {
  [RubberTypeEnum.WINTER]: 'enum.winter',
  [RubberTypeEnum.SUMMER]: 'enum.summer',
}
export const rubberTypeEnumOptions: OptionEnum<RubberTypeEnum>[] = Object.keys(
  RubberTypeEnum,
).map((value) => {
  const label = rubberTypeEnumLabels[value as keyof typeof RubberTypeEnum]
  return {
    label,
    id: value as RubberTypeEnum,
  }
})

export const incidentResponsibleEnumLabels: Record<
  IncidentResponsibleEnum,
  ParseKeys
> = {
  [IncidentResponsibleEnum.DRIVER]: 'enum.driver',
  [IncidentResponsibleEnum.NOT_DRIVER]: 'enum.not driver',
  [IncidentResponsibleEnum.UNKNOWN]: 'enum.unknown',
}
export const incidentResponsibleEnumOptions: OptionEnum<IncidentResponsibleEnum>[] =
  Object.keys(IncidentResponsibleEnum).map((value) => {
    const label =
      incidentResponsibleEnumLabels[
        value as keyof typeof IncidentResponsibleEnum
      ]
    return {
      label,
      id: value as IncidentResponsibleEnum,
    }
  })

export const repairOrderStatusEnumLabels: Record<
  RepairOrderStatusEnum,
  ParseKeys
> = {
  [RepairOrderStatusEnum.OPENED]: 'enum.opened',
  [RepairOrderStatusEnum.AWAITING_REPAIR]: 'enum.awaiting repair',
  [RepairOrderStatusEnum.AWAITING_SPARE_PARTS]: 'enum.awaiting spare parts',
  [RepairOrderStatusEnum.AT_WORK]: 'enum.at work',
  [RepairOrderStatusEnum.COMPLETED]: 'enum.completed',
}
export const repairOrderStatusEnumOptions: OptionEnum<RepairOrderStatusEnum>[] =
  Object.keys(RepairOrderStatusEnum).map((value) => {
    const label =
      repairOrderStatusEnumLabels[value as keyof typeof RepairOrderStatusEnum]
    return {
      label,
      id: value as RepairOrderStatusEnum,
    }
  })

export const repairOrderPaymentStatusEnumLabels: Record<
  RepairOrderPaymentStatusEnum,
  ParseKeys
> = {
  [RepairOrderPaymentStatusEnum.PAID]: 'enum.paid',
  [RepairOrderPaymentStatusEnum.NOT_PAID]: 'enum.not paid',
}
export const repairOrderPaymentStatusEnumOptions: OptionEnum<RepairOrderPaymentStatusEnum>[] =
  Object.keys(RepairOrderPaymentStatusEnum).map((value) => {
    const label =
      repairOrderPaymentStatusEnumLabels[
        value as keyof typeof RepairOrderPaymentStatusEnum
      ]
    return {
      label,
      id: value as RepairOrderPaymentStatusEnum,
    }
  })

export const roadAccidentsEnumLabels: Record<
  RoadAccidentsStatusEnum,
  ParseKeys
> = {
  [RoadAccidentsStatusEnum.OPENED]: 'enum.open',
  [RoadAccidentsStatusEnum.CLOSED]: 'enum.close',
}
export const roadAccidentsEnumOptions: OptionEnum<RoadAccidentsStatusEnum>[] =
  Object.keys(RoadAccidentsStatusEnum).map((value) => {
    const label =
      roadAccidentsEnumLabels[value as keyof typeof RoadAccidentsStatusEnum]
    return {
      label,
      id: value as RoadAccidentsStatusEnum,
    }
  })

export const accidentRegistrationTypeEnumLabels: Record<
  AccidentRegistrationTypeEnum,
  ParseKeys
> = {
  [AccidentRegistrationTypeEnum.EUROPROTOCOL]: 'enum.europrotocol',
  [AccidentRegistrationTypeEnum.GIBDD]: 'enum.gibdd',
}
export const accidentRegistrationTypeEnumOptions: OptionEnum<AccidentRegistrationTypeEnum>[] =
  Object.keys(AccidentRegistrationTypeEnum).map((value) => {
    const label =
      accidentRegistrationTypeEnumLabels[
        value as keyof typeof AccidentRegistrationTypeEnum
      ]
    return {
      label,
      id: value as AccidentRegistrationTypeEnum,
    }
  })

export const insurancePolicyStatusEnumLabels: Record<
  InsurancePolicyStatusEnum,
  ParseKeys
> = {
  [InsurancePolicyStatusEnum.VALID]: 'enum.valid',
  [InsurancePolicyStatusEnum.NOT_VALID]: 'enum.not valid',
}
export const insurancePolicyStatusEnumOptions: OptionEnum<InsurancePolicyStatusEnum>[] =
  Object.keys(InsurancePolicyStatusEnum).map((value) => {
    const label =
      insurancePolicyStatusEnumLabels[
        value as keyof typeof InsurancePolicyStatusEnum
      ]
    return {
      label,
      id: value as InsurancePolicyStatusEnum,
    }
  })

export const icReviewStatusEnumLabels: Record<IcReviewStatusEnum, ParseKeys> = {
  [IcReviewStatusEnum.DOCUMENTS_SUBMITTED]: 'enum.documents submitted',
  [IcReviewStatusEnum.DOCUMENTS_READY]: 'enum.documents ready',
  [IcReviewStatusEnum.INSPECTION_SCHEDULED]: 'enum.inspection scheduled',
  [IcReviewStatusEnum.REPAIR_REFERRAL_ISSUED]: 'enum.repair referral issued',
  [IcReviewStatusEnum.PAYMENT_WAITING]: 'enum.payment waiting',
  [IcReviewStatusEnum.REIMBURSED]: 'enum.reimbursed',
  [IcReviewStatusEnum.REFUSAL]: 'enum.refusal',
  [IcReviewStatusEnum.COURT_PROCEEDINGS]: 'enum.court proceedings',
}
export const icReviewStatusEnumOptions: OptionEnum<IcReviewStatusEnum>[] =
  Object.keys(IcReviewStatusEnum).map((value) => {
    const label =
      icReviewStatusEnumLabels[value as keyof typeof IcReviewStatusEnum]
    return {
      label,
      id: value as IcReviewStatusEnum,
    }
  })

export const timezoneCodeLabels: Record<TimezoneCode, ParseKeys> = {
  [TimezoneCode.KALININGRAD]: 'timezone code.kaliningrad utc+2',
  [TimezoneCode.MOSCOW]: 'timezone code.moscow utc+3',
  [TimezoneCode.SAMARA]: 'timezone code.samara utc+4',
  [TimezoneCode.YEKATERINBURG]: 'timezone code.yekaterinburg utc+5',
  [TimezoneCode.OMSK]: 'timezone code.omsk utc+6',
  [TimezoneCode.KRASNOYARSK]: 'timezone code.krasnoyarsk utc+7',
  [TimezoneCode.IRKUTSK]: 'timezone code.irkutsk utc+8',
  [TimezoneCode.YAKUTSK]: 'timezone code.yakutsk utc+9',
  [TimezoneCode.VLADIVOSTOK]: 'timezone code.vladivostok utc+10',
  [TimezoneCode.MAGADAN]: 'timezone code.magadan utc+11',
  [TimezoneCode.KAMCHATKA]: 'timezone code.kamchatka utc+12',
}
export const timezoneCodeOptions: OptionEnum<TimezoneCode>[] = Object.values(
  TimezoneCode,
).map((value) => ({
  label: timezoneCodeLabels[value as TimezoneCode],
  id: value as TimezoneCode,
}))

export const localeEnumLabels: Record<LocaleEnum, ParseKeys> = {
  [LocaleEnum.ru]: 'locale.russian',
  [LocaleEnum.en]: 'locale.english',
  [LocaleEnum.fr]: 'locale.french',
}

export const localeEnumOptions: OptionEnum<LocaleEnum>[] = Object.keys(
  LocaleEnum,
).map((value) => {
  const label = localeEnumLabels[value as keyof typeof LocaleEnum]
  return {
    label,
    id: value as LocaleEnum,
  }
})

export const STATUS_VARIANT = {
  green: {
    backgroundColor: myPalette.green['100'],
    color: myPalette.green['600'],
  },
  outlinedGreen: {
    backgroundColor: myPalette.white.main,
    color: myPalette.green['600'],
    border: `1px solid ${myPalette.green['100']}`,
  },
  red: {
    backgroundColor: myPalette.red['100'],
    color: myPalette.red['600'],
  },
  outlinedRed: {
    backgroundColor: myPalette.white.main,
    color: myPalette.red['600'],
    border: `1px solid ${myPalette.red['600']}`,
  },
  gray: {
    backgroundColor: myPalette.gray['100'],
    color: myPalette.gray['700'],
  },
  yellow: {
    backgroundColor: myPalette.yellow['100'],
    color: myPalette.yellow['600'],
  },
  brand: {
    backgroundColor: myPalette.brand['100'],
    color: myPalette.brand['700'],
  },
  blue: {
    backgroundColor: myPalette.blue['100'],
    color: myPalette.blue['600'],
  },
  purple: {
    backgroundColor: myPalette.purple['100'],
    color: myPalette.purple['600'],
  },
}
